import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#4F59CC',
    },
    secondary: {
      main: '#000000',
    },
    info: {
      main: '#4F59CC',
    },
  },
})
